import * as React from 'react';
import { CSSProperties } from 'react';

const { default: warningIcon } = require("./../../../assets/images/warning-sign-border.svg");
const { default: lockIcon } = require("./../../../assets/images/lock-icon.svg");

export enum InfoPanelIcon {
    Error = 'error',
    Locked = 'locked',
}

type InfoPanelProps = {
    title: string,
    visible: boolean,
    icon?: InfoPanelIcon,
    error?: boolean,
    className?: string,
    height?: number,
    lineHeight?: number,
    fontSize?: number,
    padding?: number,
    topAligned?: boolean,
    onClick?: () => void,
    position?: 'default' | 'fixed'
    size?: 'default' | 'small'
};

export function InfoPanel({ title, visible, height, lineHeight, fontSize, padding, topAligned, error, icon, className, onClick, position = 'default' , size = 'default' }: InfoPanelProps) {

    const onClickCb = () => {
        if (onClick) {
            onClick();
        }
    };

    const style = {} as CSSProperties;
    if (visible) {
        if (height) {
            style.height = height + 'px';
            style.maxHeight = height + 'px';
        }
        if (lineHeight) {
            style.lineHeight = lineHeight + 'px';
        }
        if (fontSize) {
            style.fontSize = fontSize + 'px';
        }
        if (padding) {
            style.padding = padding + 'px';
        }
    }

    let iconImg;

    if (icon === InfoPanelIcon.Error) {
        iconImg = warningIcon;
    }

    if (icon === InfoPanelIcon.Locked) {
        iconImg = lockIcon;
    }



    return (
        <div
            className={`info-panel ${visible && 'visible'} ${error && 'error'} ${className} ${topAligned && 'top-aligned'} ${onClick && 'actionable'} ${position}-position ${size}-size`}
            style={style}
            onClick={onClickCb}
        >
            <img src={iconImg} /> {title}
        </div>
    );
}